import React from 'react';
import { Link } from 'react-router-dom';


function Footer(props) {
    return (
        <footer>
            <div className="container">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="footer-logo">
                            <div className="footer-title"> About Panacea </div> <br />
                            <p className="footer-content" >
                            Panacea is a versatile digital toolkit crafted to simplify your tasks and enhance productivity. Offering tools for text, code, and image editing, Panacea empowers developers, content creators, and professionals to work smarter. Your efficiency, privacy, and satisfaction are our priorities.                            </p>
                        </div>
                    </div>
                    <div className="col-lg-2 col-sm-4">
                        <ul className="footer-tab">
                            <li><span className="footer-tab-title">Quick Links</span></li>
                            <li><Link to="/">{props.quicklink}</Link></li>
                            <li><Link to="/insights">{props.quicklink1}</Link></li>
                            <li><Link to="/contact">{props.quicklink2}</Link></li>
                           
                        </ul>
                    </div>
                    <div className="col-lg-2 col-sm-4">
                        <ul className="footer-tab">
                            <li><span className="footer-tab-title">Services</span></li>
                            <li><Link to="/text-gizmo">{props.service}</Link></li>
                            <li><Link to="/image-gizmo">{props.service1}</Link></li>
                            <li><Link to="/pdf-gizmo">{props.service2}</Link></li>
                            {/* <li><Link to="">{props.service3}</Link></li> */}
                        </ul>
                    </div>
                    <div className="col-lg-2 col-sm-4">
                        <ul className="footer-tab">
                            <li><span className='footer-tab-title'>Contact Information</span></li>
                            {/* <li>291 SOUTH 21TH STREET, SUITE 721 NEW YORK NY 10016</li> */}
                            {/* <li>+ 1235 2355 98</li> */}
                            <li>bhimanidarshan909@gmail.com</li>
                            <li><Link to="https://darshan-bhimani.pages.dev/" target='_blank'> Get Support </Link></li>
                        </ul>
                    </div>
                </div>
            </div>
            <hr />
            <div className="col-12" id="copyright">
                Copyright © 2025. All rights reserved by Panacea. Designed and Developed by <Link to="https://darshan-bhimani.pages.dev/" target='_blank' > Darshan Bhimani. </Link>
            </div>
        </footer>
    );
};

export default Footer;

